/**
 * Medium Zoom
 * https://github.com/francoischalifour/medium-zoom
 */

import mediumZoom from 'medium-zoom';

mediumZoom('.zoom', {
  margin: 24,
  background: '#1B2022',
  scrollOffset: 0,
});
